import { PageHead } from 'ui/kit/PageHead';
import { Link, useParams } from 'react-router';

import { useWalletCheckoutSession } from 'hooks/useTutorWallet';
import { formatRubFull } from 'utils/formatMoneyRu';

import classes from './t3Screen.module.scss';

const STATUS_LABEL: Record<string, string> = {
  pending: 'Ожидает подтверждения провайдера',
  processing: 'Проверяется провайдером',
  succeeded: 'Пополнение выполнено',
  failed: 'Провайдер не подтвердил оплату',
  expired: 'Срок оплаты истек',
};

export const TeacherWalletCheckout = () => {
  const { token } = useParams<{ token: string }>();
  const { data: session, isLoading, error } = useWalletCheckoutSession(token);

  if (isLoading) {
    return (
      <main className={classes.page}>
        <PageHead crumb={<>Личный кабинет / Кошелек</>} title={<>Оплата</>} />
        <p className={classes.body}>Загрузка платежной сессии...</p>
      </main>
    );
  }

  if (error || !session) {
    return (
      <main className={classes.page}>
        <PageHead crumb={<>Личный кабинет / Кошелек</>} title={<>Оплата</>} />
        <section className={classes.card}>
          <p className={classes.body}>Сессия оплаты не найдена или истекла.</p>
          <Link to='/teacher/wallet' className={classes.primary}>
            Вернуться к балансу
          </Link>
        </section>
      </main>
    );
  }

  const statusLabel = STATUS_LABEL[session.status] ?? session.status;
  const done = session.status === 'succeeded';

  return (
    <main className={classes.page}>
      <PageHead
        crumb={<>Личный кабинет / Кошелек</>}
        title={<>{done ? 'Пополнение выполнено' : 'Оплата'}</>}
      />
      <section className={classes.card}>
        <h2 className={classes.cardTitle}>
          {session.test_mode ? 'Демо-страница провайдера' : session.provider_label}
        </h2>
        {session.test_mode ? <p className={classes.small}>Демо</p> : null}
        <p className={classes.amount}>{formatRubFull(session.amount_rub)}</p>
        <p className={classes.muted}>
          Заказ уже создан на сервере. Сумма и валюта здесь не меняются. Номер карты и код
          безопасности на сайт MyTeacher не отправляются.
        </p>
        <p className={classes.body}>
          {session.test_mode
            ? 'Это демо-переход на страницу заказа. Деньги не списываются. Статус сменится только после серверного события провайдера.'
            : 'Дальше откроется страница банка. Статус заказа обновится после проверки подписи уведомления банка.'}
        </p>
        <div className={classes.line}>
          <strong>Статус</strong>
          <span>{statusLabel}</span>
        </div>
        <Link to='/teacher/wallet' className={classes.primary}>
          Вернуться к балансу
        </Link>
      </section>
    </main>
  );
};
